import { lazy, Suspense } from 'react';
import { Navigate, RouteObject } from 'react-router';

const ClassesLayout = lazy(() => import('../shared/components/ClassesLayout'));
const ClassFinder = lazy(() => import('../modules/ClassFinder/ClassFinder'));

const Activation = lazy(
  () => import('../modules/ClassRegistration/components/Activation')
);

const ClassJoined = lazy(
  () => import('../modules/ClassRegistration/components/ClassJoined')
);

const DropClassConfirmation = lazy(
  () => import('../modules/ClassRegistration/components/DropClassConfirmation')
);

const SpouseJoining = lazy(
  () => import('../modules/ClassRegistration/components/SpouseJoining')
);

const UniqueClassPage = lazy(
  () => import('../modules/UniqueClassPage/UniqueClassPage')
);

const LOADING_FALLBACK = null;

const routes: RouteObject[] = [
  {
    // /classes
    path: 'classes',
    element: (
      <Suspense fallback={LOADING_FALLBACK}>
        <ClassesLayout />
      </Suspense>
    ),
    children: [
      {
        // /classes
        path: 'guide',
        element: (
          <Suspense fallback={LOADING_FALLBACK}>
            <ClassFinder />
          </Suspense>
        )
      },
      {
        // /classes/:id
        path: ':id',
        element: (
          <Suspense fallback={LOADING_FALLBACK}>
            <UniqueClassPage />
          </Suspense>
        )
      },
      {
        // /classes/registration/activation/:class_code?
        path: 'registration/activation/:class_code?',
        element: (
          <Suspense fallback={LOADING_FALLBACK}>
            <Activation />
          </Suspense>
        )
      },
      {
        // /classes/registration/partner
        path: 'registration/partner',
        element: (
          <Suspense fallback={LOADING_FALLBACK}>
            <SpouseJoining />
          </Suspense>
        )
      },
      {
        // /classes/registration/success
        path: 'registration/success',
        element: (
          <Suspense fallback={LOADING_FALLBACK}>
            <ClassJoined />
          </Suspense>
        )
      }
    ]
  },

  {
    // /classes/my-class/remove/:classCode/:lmsCohortId
    path: '/classes/my-class/remove/:classCode/:lmsCohortId',
    element: (
      <Suspense fallback={LOADING_FALLBACK}>
        <DropClassConfirmation />
      </Suspense>
    )
  },
  {
    // /classes/guide/virtual -> /classes/guide
    path: '/classes/guide/virtual',
    element: <Navigate replace to="/classes/guide" />
  },
  {
    // /classes/guide/in-person -> /classes/guide
    path: '/classes/guide/in-person',
    element: <Navigate replace to="/classes/guide" />
  }
];

export default routes;
